import { JsonObject, JsonProperty } from "json2typescript";

@JsonObject("UserInfo")
export class UserInfo {

    @JsonProperty("username",String)
    public username: string= ""

    @JsonProperty("userid", String)
    public user_id: string = ""

}


// WEBPACK FOOTER //
// ./src/models/UserInfo.ts